import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=617b58ba&scoped=true&"
import script from "./Audit.vue?vue&type=script&lang=js&"
export * from "./Audit.vue?vue&type=script&lang=js&"
import style0 from "../CGC.scss?vue&type=style&index=0&id=617b58ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b58ba",
  null
  
)

export default component.exports